import React from 'react';
import SMRoomResource from 'resources/SMRoomResource';
import SMPlanHelper from 'components/helpers/SMPlanHelper';
import SMConst from 'lib/SMConst';
import sprintf from 'sprintf';
import CSSTransitionGroup from 'react-addons-css-transition-group';

class SMReservationCalendarView extends React.Component {

  constructor(props) {
    super(props);
    const date = new Date();
    this.state = this.resetState(date);
  }

  componentDidMount() {
    const date = new Date();
    this.requestMonthlyResource(date);
  }
  
  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.plan != this.props.plan || prevProps.isHourly != this.props.isHourly) {
      const date = new Date();
      this.setState(this.resetState(date));
      this.requestMonthlyResource(date);
    }
  }
  
  resetState(date) {
    return {
      monthlyCalendars: [],
      dailyCalendars: [],
      selectedDate: null,
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: null,
    };
  }
  
  requestMonthlyResource(date) {
    const plan = this.props.plan;
    
    let queries = SMPlanHelper.isRoom(plan) ? {} : {plan_id: plan.id};
    queries.year = date.getFullYear();
    queries.month = date.getMonth() + 1;
    queries.is_hourly = this.props.isHourly;
    
    $(this.refs.calendarContainer).startLoading();
    SMRoomResource.getCalendar(this.props.room.id, queries, (calendars, error)=>{
      $(this.refs.calendarContainer).stopLoading();
      if(!error) {
        this.setState({
          monthlyCalendars: calendars,
          year: queries.year,
          month: queries.month,
        });
        $("body").animate({scrollTop: $(this.refs.calendarContainer).offset().top - 80}, 500);
      }
    });
  }
  
  requestDailyResource() {
    const plan = this.props.plan;
    let queries = SMPlanHelper.isRoom(plan) ? {} : {plan_id: plan.id};
    queries.year = this.state.year;
    queries.month = this.state.month;
    queries.day = this.state.day;
    queries.is_hourly = this.props.isHourly;
    
    $("body,html").animate({scrollTop: $(this.refs.dailyTable).offset().top - 80}, 500);
    $(this.refs.dailyTable).startLoading();
    SMRoomResource.getCalendar(this.props.room.id, queries, (calendars, error)=>{
      $(this.refs.dailyTable).stopLoading();
      if(!error) {
        this.setState({
          dailyCalendars: calendars
        });
      }
    });
  }
  
  toYMD(date, divider) {
    divider = divider || "";
    var y = date.getUTCFullYear(),
        m = date.getUTCMonth() + 1,
        d = date.getUTCDate();
    return sprintf("%04d%s%02d%s%02d", y, divider , m , divider , d);
  }
  
  nextMonth(e) {
    e.preventDefault();
    var date = new Date(
      this.state.year,
      this.state.month,
      1
    );
    this.requestMonthlyResource(date);
  }
  
  prevMonth(e) {
    e.preventDefault();
    const date = new Date(
      this.state.year,
      this.state.month - 2,
      1
    );
    this.requestMonthlyResource(date);
  }
  
  nextDay(e) {
    e.preventDefault();
  }
  
  prevDay(e) {
    e.preventDefault();
  }
  
  dayDidSelect(selectedDay, e) {
    e.preventDefault();
    if (this.props.isHourly == 1) {
      this.setState({
        day: selectedDay,
      });
      setTimeout(()=>{
        this.requestDailyResource();
      }, 1);
    } else {
      
      const plan = this.props.plan;
      const startedAt = new Date(Date.UTC(this.state.year, this.state.month - 1, selectedDay));
      let isSessionStart = false;
      let duration = 60 * 24;
      if (plan.has_session_price) {
        duration *= plan.min_required_session_hour;
        isSessionStart = true;
      }
      this.props.delegate.scheduleDidSelect(startedAt, duration, isSessionStart);
    }
  }
  
  hourDidSelect(selectedHour, e) {
    e.preventDefault();
    const plan = this.props.plan;
    const startedAt = new Date(Date.UTC(this.state.year, this.state.month - 1, this.state.day, selectedHour));
    let isSessionStart = false;
    let duration = 60;
    if (plan.has_session_price) {
      duration *= plan.min_required_session_hour;
      isSessionStart = true;
    }
    if(this.props.delegate && typeof this.props.delegate.scheduleDidSelect === 'function'){
      this.props.delegate.scheduleDidSelect(startedAt, duration, isSessionStart);
    }
  }
  
  renderMonthly() {
    let weekDay = 0;
    let rows = [];
    let cols = [];
    const monthFirst = this.toYMD(new Date(Date.UTC(this.state.year, this.state.month - 1, 1)));
    const monthLast = this.toYMD(new Date(Date.UTC(this.state.year, this.state.month, 0)));
    const now = new Date();
    const interval = 60 * 24;
    
    this.state.monthlyCalendars.forEach((calendar, index)=>{
      let classes = [];
      const currentDate = new Date(Date.UTC(calendar.year, calendar.month - 1, calendar.day));
      const current = this.toYMD(currentDate); 
      
      let isCurrentMonth = true;
      
      if (cols.length == 0 || cols.length == 6) {
        //classes.push("is-holiday");
      }
      if (current < monthFirst) {
        isCurrentMonth = false;
      }
      if (current > monthLast) {
        isCurrentMonth = false;
      }
      if (current == this.toYMD(now)) {
        classes.push("is-today");
      }
      if (this.state.month == calendar.month && this.state.day == calendar.day) {
        classes.push("is-select");
      }
      this.props.reservation.reserved_schedules.some((schedule)=>{
        for (var i = 0; i < schedule.duration; i += interval) {
          const date = new Date(schedule.started_at);
          date.setUTCDate(date.getUTCDate() + i / interval);
          if (current == this.toYMD(date)) {
            if (this.props.plan.has_session_price) {
              if (i == 0) {
                classes.push("is-checked");
                classes.push("is-reserved");
              } else {
                classes.push("is-reserved");
              }
            } else {
              classes.push("is-checked");
              classes.push("is-reserved");
            }
            return true;
          }
        }
      });
      const key = current;
      
      if (!isCurrentMonth) {
        classes.push("is-past");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done"></p>
            </div>
          </td>
        );
      }
      else if(calendar.status == SMConst.RoomStatus.Available) {
        const priceSuffix = this.props.isHourly ? "〜" : "";
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <a onClick={this.dayDidSelect.bind(this, calendar.day)} href="#" className="dashboard-calendar__cell-wrap">
              <p className="dashboard-calendar__date">{calendar.day}</p>
              <div className="reserve-period__calendar-content">
                <p className="reserve-period__calendar-price">{calendar.price_text}{priceSuffix}</p>
                <p className="reserve-period__calendar-check"><i className="fa fa-check"></i></p>
              </div>
            </a>
          </td>
        );
      }
      else if (calendar.status == SMConst.RoomStatus.Full || calendar.status == SMConst.RoomStatus.Request || calendar.status == SMConst.RoomStatus.Interval) {
        classes.push("is-unavailable");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done">{calendar.status_text}</p>
            </div>
          </td>
        );
      }
      else {
        classes.push("is-closed");
        cols.push(
          <td key={key} className={classes.join(" ")}>
            <p className="dashboard-calendar__date">{calendar.day}</p>
            <div className="reserve-period__calendar-content">
              <p className="reserve-period__calendar-done">{calendar.status_text}</p>
            </div>
          </td>
        );
      }
      
      if (cols.length == 7) {
        rows.push(<tr key={rows.length}>{cols}</tr>);
        cols = [];
      }
    });
    rows.push(<tr key={rows.length}>{cols}</tr>);
    return rows;
  }
  
  renderDaily() {
    if (this.props.isHourly != 1 || !this.state.day) return null;
    let rows = [];
    const interval = 60;
    const reservedSchedules = this.props.reservation.reserved_schedules;
    this.state.dailyCalendars.forEach((calendar, index)=>{
      if (calendar.status == SMConst.RoomStatus.Available || calendar.status == SMConst.RoomStatus.SessionPriceBlock) {
        const  isSessionPriceBlock = calendar.status == SMConst.RoomStatus.SessionPriceBlock;
        
        let className = isSessionPriceBlock ? "is-closed" : "",
            targetHour = index >= 24 ? index - 24 : index;
        reservedSchedules.some((schedule)=>{
          for (var i = 0; i < schedule.duration; i += interval) {
            let date = new Date(schedule.started_at);
            date.setUTCHours(date.getUTCHours() + i / interval);
            if (calendar.year == date.getUTCFullYear() && calendar.month == date.getUTCMonth() + 1 &&
                calendar.day == date.getUTCDate() && targetHour == date.getUTCHours()) {
              if (this.props.plan.has_session_price) {
                if (i == 0) {
                  className = "is-reserved is-checked";
                } else {
                  className = "is-reserved";
                }
              } else {
                className = "is-reserved is-checked";
              }
              return true;
            }
          }
        });
        
        if (isSessionPriceBlock) {
          rows.push(
            <li className={className} key={index}>
              <div className="reserve-period__hourly-content">
                <span className="reserve-period__hourly-time">{calendar.hour}:00 - {calendar.hour + 1}:00</span>
                <span className="reserve-period__hourly-status">{calendar.price_text}</span>
              </div>
            </li>
          );          
        } else {
          rows.push(
            <li className={className} key={index}>
              <a onClick={this.hourDidSelect.bind(this, index)} href="#">
                <div className="reserve-period__hourly-content">
                  <span className="reserve-period__hourly-time">{calendar.hour}:00 - {calendar.hour + 1}:00</span>
                  <span className="reserve-period__hourly-status">{calendar.price_text}</span>
                </div>
              </a>
            </li>
          );
        }
      }
      else if (calendar.status == SMConst.RoomStatus.Full || 
        calendar.status == SMConst.RoomStatus.Disable ||
        calendar.status == SMConst.RoomStatus.Request ||
        calendar.status == SMConst.RoomStatus.Interval) {
        rows.push(
          <li key={index} className="is-unavailable">
            <div className="reserve-period__hourly-content">
              <span className="reserve-period__hourly-time">{calendar.hour}:00 - {calendar.hour + 1}:00</span>
              <span className="reserve-period__hourly-status">{calendar.status_text}</span>
            </div>
          </li>
        );
      }
      else {
        rows.push(
          <li key={index} className="is-closed">
            <div className="reserve-period__hourly-content">
              <span className="reserve-period__hourly-time">{calendar.hour}:00 - {calendar.hour + 1}:00</span>
              <span className="reserve-period__hourly-status">{calendar.status_text}</span>
            </div>
          </li>
        );
      }
    });
    return(
      <ul ref="dailyTable" className="js-daily-table reserve-period__hourly">
        <CSSTransitionGroup transitionName="js-list-fade-animation" transitionEnterTimeout={500} transitionLeaveTimeout={300}>
        {rows}
        </CSSTransitionGroup>
      </ul>
    );
  }
  
  render() {

    const room = this.props.room;
    const yearText = sprintf("%s年", this.state.year);
    const monthText = sprintf("%s月", this.state.month);
    const timeStyle = {display: "none"};

    return(
      <div ref="calendarContainer" className="js-monthly-table__container reserve-card sm-hide__guteter">
        <div className="reserve-card__inner clearfix">
          <div className="reserve-card__inner__calendar">
            <div className="reserve-period__header">
              <a onClick={this.prevMonth.bind(this)} href="#" className="reserve-period__header-navi"><i className="fa fa-angle-left"></i></a>
              <h2 className="reserve-period__title">{yearText}<span className="reserve-period__title-month">{monthText}</span></h2>
              <a onClick={this.nextMonth.bind(this)} href="#" className="reserve-period__header-navi"><i className="fa fa-angle-right"></i></a>
            </div>
            <table ref="monthlyTable" className="js-monthly-table reserve-period__calendar dashboard-calendar__table">
              <tbody>
                <tr>
                  <th className="is-holiday">{I18n.t("datetime.Sun")}</th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Mon")}</div></th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Tue")}</div></th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Wed")}</div></th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Thu")}</div></th>
                  <th><div className="dashboard-calendar__cell-wrap">{I18n.t("datetime.Fri")}</div></th>
                  <th className="is-holiday">{I18n.t("datetime.Sat")}</th>
                </tr>
                {this.renderMonthly()}
              </tbody>
            </table>
            {this.renderDaily()}
          </div>
        </div>
      </div>
    );
  }

}

export default SMReservationCalendarView;


// WEBPACK FOOTER //
// ./app/javascript/components/reservations/SMReservationCalendarView.jsx